// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');

// @ actions
const signaturePatternActions = require('actions/signaturePattern');

// @vendors
const { Promise } = require('es6-promise');
const get = require('lodash/object/get');

// @utilities
const { APIGet, APIPost} = require('utilities/APIRequestHelper');
const transfersHelper = require('utilities/transfersHelper');

// @ constants
const {
    ECONOMIC_CODE_DEFAULT,
    NONE_SEPA,
} = require('constants/index');

const beneficiariesRequest = () => ({
    type: actionTypes.FETCH_BENEFICIARIES_REQUEST
});

const beneficiariesSuccess = (data) => ({
    type: actionTypes.FETCH_BENEFICIARIES_SUCCESS,
    payload: {
        beneficiaries: get(data, 'beneficiarios.beneficiario', []),
        economicCode: data.organismoEconomico || '',
        contract: get(data, 'contratoMulticanal')
    }
});

const beneficiariesFailure = (error) => ({
    type: actionTypes.FETCH_BENEFICIARIES_FAILURE,
    payload: {
        error
    }
});

const requestBeneficiariesFetch = () => (dispatch) => {
    const requestData = {
        header: {
            version: 2
        },
        query: {
            completeResult: true
        }
    };
    dispatch(beneficiariesRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('beneficiaries'), requestData)
        .then(response => dispatch(beneficiariesSuccess(response)))
        .catch(response => dispatch(beneficiariesFailure(response.error)))
}

const requestBeneficiaries = () => (dispatch, getState) => {
    const immBeneficiaries = getState().beneficiaries;

    const isAlreadyFetching = immBeneficiaries.get('isFetching');
    const hasError = !!immBeneficiaries.get('error');
    const isOutdated = immBeneficiaries.get('isOutdated');
    const fetchSuccess = immBeneficiaries.get('fetchSuccess');

    if (!isOutdated && fetchSuccess) {
        return Promise.resolve();
    } else if ((!isAlreadyFetching && !hasError)) {
        return dispatch(requestBeneficiariesFetch());
    } else {
        return Promise.reject();
    }
}

const removeBeneficiaryRequest = () => ({ type: actionTypes.REMOVE_BENEFICIARY_REQUEST });

const removeBeneficiarySuccess = () => ({ type: actionTypes.REMOVE_BENEFICIARY_SUCCESS });

const removeBeneficiaryFailure = () => ({ type: actionTypes.REMOVE_BENEFICIARY_FAILURE });

const setRemoveDefaultValues = ()  => ({ type: actionTypes.SET_REMOVE_BENEFICIARY_DEFAULT_VALUES });

const requestRemoveBeneficiary = (beneficiaryId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immBeneficiary = getState().beneficiaries.get('byId').get(beneficiaryId);
        const requestData = {
            header: {
                version: 2
            },
            query: {
                dataToken,
                alias: immBeneficiary.get('alias'),
                tipoDestinatario: immBeneficiary.getIn(['extra', 'type'])
            }
        }

        dispatch(removeBeneficiaryRequest());
        APIPost(dispatch, apiURLBuilder.getURL('removeBeneficiary'), requestData)
            .then(response => dispatch(removeBeneficiarySuccess(response)))
            .catch(error => {
                dispatch(removeBeneficiaryFailure(error));
                throw error;
            });
    }
    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

const beneficiaryDetailsFetch = beneficiaryId => ({
    type: actionTypes.BENEFICIARY_DETAILS_FETCH,
    payload: {
        beneficiaryId
    }
});

const beneficiaryDetailsSuccess = (beneficiaryId, data) => ({
    type: actionTypes.BENEFICIARY_DETAILS_SUCCESS,
    payload: {
        beneficiaryId,
        data
    }
});

const beneficiaryDetailsFailure = (beneficiaryId, data) => ({
    type: actionTypes.BENEFICIARY_DETAILS_FAILURE,
    payload: {
        beneficiaryId,
        error: data.errorDescription
    }
});

const requestBeneficiaryDetails = beneficiaryId => (dispatch, getState) => {
    const immBeneficiary = getState().beneficiaries.getIn(['byId', beneficiaryId]);
    const sepaType = transfersHelper.getSepaTypeTransfers(immBeneficiary.get('country'), immBeneficiary.get('currency'), immBeneficiary.get('iban'));
    if (sepaType === NONE_SEPA && !immBeneficiary.get('fetchDetailsSuccess')) {
        const economicCode = immBeneficiary.getIn(['extra', 'economicCode']);
        const params = {
            query: {
                alias: immBeneficiary.get('alias'),
                organismoEconomico: !!economicCode ? economicCode : ECONOMIC_CODE_DEFAULT,
                pais: immBeneficiary.get('country'),
                tipoDestinatario: immBeneficiary.getIn(['extra', 'type'])
            }
        };

        dispatch(beneficiaryDetailsFetch(beneficiaryId));
        APIGet(dispatch, apiURLBuilder.getURL('beneficiaryDetails'), params)
            .then(
                response => dispatch(beneficiaryDetailsSuccess(beneficiaryId, response)),
                response => dispatch(beneficiaryDetailsFailure(beneficiaryId, response))
            );
    }
}

const transferBeneficiary = (alias, history) => (dispatch, getState) => {
    dispatch(requestBeneficiaries())
        .then(() => {
            const immBeneficiary = getState().beneficiaries;
            const beneficiaryId = immBeneficiary.get('byOrder').find( beneficiaryId => {
                return immBeneficiary.getIn(['byId', beneficiaryId, 'alias']) === alias;
            });

            if (beneficiaryId) {
                history.push(`/myprofile/transfers/transfer/beneficiary/${beneficiaryId}`);
            }
        });
};

module.exports = {
    requestBeneficiaries,
    requestBeneficiaryDetails,
    requestRemoveBeneficiary,
    setRemoveDefaultValues,
    transferBeneficiary
}
